import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { BzgModalService, BzgToastService } from 'bz-genome-angular';
import { ChangeAdministratorDialogComponent } from './change-administrator-dialog/change-administrator-dialog.component';
import { AuthClient } from 'app/auth/auth.client';


@Component({
    selector: 'change-administrator',
    templateUrl: 'change-administrator.component.html',
    styleUrls: ['change-administrator.component.scss']
})
export class ChangeAdministratorComponent {
    public userName = '';

    constructor(private _translateService: TranslateService,
        private _toastService: BzgToastService,
        private _autoLoginClient: AutoLoginClient,
        private _modalService: BzgModalService,
        private _authClient: AuthClient) { }

    ngOnInit() {
        this._autoLoginClient.getProfile()
            .subscribe((response) => {
                this.userName = response && response.username ? response.username : '';
            });
    }

    public changeAdministrator() {
        const deleteModal =  this._modalService.open(
          ChangeAdministratorDialogComponent,
          {closeOnBackdropClick: false, closeOnRouterNavigation: true}
        );
        deleteModal.afterClosed().subscribe((result: any) => {
            if (result && result.userName) {
                this._autoLoginClient.changeAdministrator(result.userName)
                    .subscribe((response) => {
                        switch (response) {
                            case 'ChangeAdministratorSucessful':
                                this.userName = result.userName;
                                break;
                                case 'ChangeAdministratorUsernameInUse':
                                this._translateService.get('CHANGE_ADMINISTRATOR.SELECT_OTHER_EMAIL').subscribe((message: string) => {
                                    this._toastService.open(
                                        message,
                                        {
                                            type: 'error',
                                            duration: 0,
                                            verticalPosition: 'bottom',
                                            horizontalPosition: 'right'
                                        });
                                });
                                break;
                                case 'ChangeAdministratorUnexpectedError':
                                this._translateService.get('GLOBAL.GENERIC_ERROR_MSG').subscribe((message: string) => {
                                    this._toastService.open(
                                        message,
                                        {
                                            type: 'error',
                                            duration: 0,
                                            verticalPosition: 'bottom',
                                            horizontalPosition: 'right'
                                        });
                                });
                                break;
                            default:
                                break;
                        }
                    });
            }
        })
    }
}
